














import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import FormBase from '@/components/helper/form-base.vue';
import VWidget from '@/components/VWidget.vue';

@Component({
    components: { VWidget, FormBase }
})
export default class Departments extends ListBase {
    model: any = {};
    formBase: boolean = false;

    get saving() {
        return this.$store.state.configuration.loading;
    }

    items = [
        this.gItem({ type: 'spacer', size: 12 }),
        this.gItem({ type: 'object', prop: 'APPLY_STATE_NU', label: 'Alerta Para Solicitudes Nuevas', entity: 'alert', loadOptions: false, size: 6 }),
        this.gItem({ type: 'object', prop: 'APPLY_STATE_VE', label: 'Alerta Para Solicitudes Verificadas', entity: 'alert', loadOptions: false, size: 6 }),
        this.gItem({ type: 'object', prop: 'APPLY_STATE_CO', label: 'Alerta Para Solicitudes Confirmadas', entity: 'alert', loadOptions: false, size: 6 }),
        this.gItem({ type: 'object', prop: 'APPLY_STATE_OB', label: 'Alerta Para Solicitudes Observadas', entity: 'alert', loadOptions: false, size: 6 }),
        this.gItem({ type: 'object', prop: 'APPLY_STATE_RE', label: 'Alerta Para Solicitudes Revisadas', entity: 'alert', loadOptions: false, size: 6 }),
        this.gItem({ type: 'object', prop: 'APPLY_STATE_AP', label: 'Alerta Para Solicitudes Aprobadas', entity: 'alert', loadOptions: false, size: 6 }),
        this.gItem({ type: 'object', prop: 'APPLY_STATE_DE', label: 'Alerta Para Solicitudes Desistida', entity: 'alert', loadOptions: false, size: 6 }),
        this.gItem({ type: 'object', prop: 'APPLY_COMITE', label: 'Alerta Para Aprobacion de Comite', entity: 'alert', loadOptions: false, size: 6 }),
        this.gItem({ type: 'spacer', size: 6 }),
    ]

    buildModel(data) {
        let model = { };
        this.items.forEach(item => {
            if (item.prop != undefined && typeof data[item.prop] == "object") {
                var prop = item.prop;
                if (data[item.prop] != undefined) {
                    model[prop] = data[item.prop].id;
                }
            } else if (item.prop != undefined) {
                model[item.prop] = data[item.prop];
            }

        });
        return model;
    }

    async save() {           
        let model = this.buildModel(this.model);
        await this.$store.dispatch({
            type: 'configuration/save',
            data: model
        });
        Util.abp.notify.success(this, 'Las opciones de Roles fueron actualizadas!');
    }

    mounted() {
        this.model = Util.extend(true, {}, Util.abp.setting.values);
    }

    async created() {
        this.formBase = true;
        await this.$store.dispatch({
            type: 'alert/getAllActive',
            data: { force: true}
        });
    }
}
